var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"f-search",domProps:{"value":_vm.v},on:{"input":function($event){_vm.$emit('input', $event.target.value.replace(',', '.'))},"change":function($event){_vm.$emit('change', $event.target.value.replace(',', '.'))}}})
}
var staticRenderFns = []

export { render, staticRenderFns }